import { OfferAccess, OfferBalanceAffiliateBilling, OfferStatus } from "types/enums";
import { z } from "zod";

export const schema = z.object({
    title: z.string().min(1, "forms.general-validation.title_required"),
    visible_title: z.string().min(1, "forms.general-validation.visible_title_required"),
    advertiser_id: z.string().optional(),
    currency_id: z.number(),
    country_id: z.number().nullable().optional(),
    category: z.string().optional(),
    logo: z.string().optional().nullable(),
    label_ids: z.array(z.string()).optional(),
    status: z.nativeEnum(OfferStatus),
    enabled_from: z.string().optional().nullable(),
    integrations: z.array(z.string()).optional(),
    access: z.nativeEnum(OfferAccess),
    partners: z.array(z.string()).optional(),
    description: z.string().optional().nullable(),
    affiliate_billing: z.nativeEnum(OfferBalanceAffiliateBilling),
});

export type OfferEditGeneralFormData = z.infer<typeof schema>;
